<template>
  <div class="nps-wrap" :class="page == 2 ? 'left' : ''">
    <user-token-site-name :user-token="user_token" @updateSiteInfo="updateSiteInfo" />
    <!-- <div class="pointer" style="position:fixed; right:30px; z-index:1" @click="back()" v-if="page == 2">
      <font-awesome-icon :icon="['far', 'long-arrow-left']" style="margin-right: 5px;" />
      戻る
    </div> -->
    <div class="nps-content-wrap">
      <div class="nps-content" v-if="page == 1">
        <div class="nps-description">
          {{ siteName }} の満足度をお教えいただけませんか？
        </div>
        <div class="nps-score-wrap">
          <div class="flex-row">
            <div class="nps-score-description">とても不満足</div>
            <div class="nps-score">
              <div v-for="n in 10" :key="n" class="nps-score-num pointer" :class="n == score ? 'on' : ''" @click="next(n)">{{ n }}</div>
            </div>
            <div class="nps-score-description">とても満足</div>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class="nps-content" v-if="page == 2">
          <div class="nps-description-after">
            <div v-if="score >= 5" style="font-size:20px">
              {{ score }}<span style="font-size:10px; margin-right:5px">点</span>
              <span v-if="score >= 9">🤩</span>
              <span v-else-if="score >= 7">😄</span>
              <span v-else-if="score >= 5">😀</span>
            </div>
            <div>
              ご回答ありがとうございます。
              <span v-if="score < 9"> 差し支えなければ、<br />改善点やご要望、欲しい機能などをお教えください。 </span>
              <span v-else> 差し支えなければ、<br />ご評価いただいたポイントをお教えください。 </span>
            </div>
          </div>
          <el-input
            type="textarea"
            :rows="2"
            v-model="feedback"
            style="width:420px"
            :placeholder="score < 9 ? '改善点やご要望、欲しい機能などを教えてください' : 'ご評価いただいたポイントを教えてください'"
          ></el-input>
          <el-button type="info" style="margin-left: 20px; width: 120px" @click="submit()">
            <div class="flex-row">
              <div v-if="!loading">送信して閉じる</div>
              <div class="loader--mini blue" v-else></div>
            </div>
          </el-button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const npsAPI = root + "/api/dashboard/nps";
import UserTokenSiteName from "./oem/UserTokenSiteInfo.vue";

export default {
  name: "NPS",
  components: {
    UserTokenSiteName,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    return {
      page: 1,
      score: "",
      feedback: "",
      loading: false,
      siteName: 'REECH DATABASE',
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
  },
  methods: {
    next(n) {
      this.page = 2;
      this.score = n;
    },
    back() {
      this.score = "";
      this.page = 1;
    },
    submit() {
      this.loading = true;
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("user_token", this.user_token);
      params.append("score", this.score);
      params.append("feedback", this.feedback);
      this.axios
        .post(npsAPI, params)
        .then(() => {
          setTimeout(() => {
            this.loading = false;
            this.$store.dispatch("headerNotification", false);
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: "ご回答ありがとうございました。頂戴したご回答を基にサービスの改善に努めさせていただきます。",
            });
          }, 500);
        })
        .catch(() => {});
    },
    updateSiteInfo({siteName}) {
      this.siteName = siteName;
    },
  },
};
</script>
